export default __webpack_public_path__ + "static/media/rejected.e2916942.png";